import React from 'react';

const Tooltip = ({ text }) => {
  return (

    <div className="group relative m-12 flex justify-center">
  <button className="rounded bg-amber-500 px-4 py-2 text-sm text-white shadow-sm">Hover me!</button>
  {text.map((item, index) => (
            <span className="absolute top-10 scale-0 rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100" >✨ {item}</span>
          ))}
</div>
  );
};

export default Tooltip;
